import { useEffect, useRef } from "react";
import { useQueryClient } from "react-query";
import config from "../config/config";

const STATIONDISPLAY = "/stationdisplays";

export const useDisplaySSE = (locationId) => {
  const queryClient = useQueryClient();
  const eventSourceRef = useRef(null);

  useEffect(() => {
    const url = `${config.apiHost}/sse/displays?locationId=${locationId || ""}`;
    const es = new EventSource(url, { withCredentials: true });
    eventSourceRef.current = es;

    es.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === "update") {
          queryClient.invalidateQueries(STATIONDISPLAY);
        }
      } catch (_) {}
    };

    es.onerror = () => {
      // Browser auto-reconnects EventSource on error
    };

    return () => {
      es.close();
      eventSourceRef.current = null;
    };
  }, [locationId, queryClient]);
};

export default useDisplaySSE;
